import './styles.css'

import { HStack, IconButton, Image, Text, VStack } from '@chakra-ui/react'
import LoadingAnimation from '@editor/assets/imgs/loading-animation-black.gif'
import { PanelType } from '@editor/config/constants'
import { INFO_PANEL_WIDTH } from '@editor/config/styles'
import { WithToolsConfig } from '@editor/interfaces/editor'
import { RootState, useAppDispatch } from '@editor/store/app'
import { MeshState } from '@infraloop/common'
import { ChevronRightIcon } from '@infraloop/common'
import { useSelector } from 'react-redux'

import { setCollapsedPanel } from '../store/editor'
import { ElementsPanel } from './ElementsPanel'
import SettingsPanel from './SettingsPanel'
import ToolsPanel from './ToolsPanel'

const SidePanels = ({ toolsConfig }: WithToolsConfig) => {
  // Store
  const dispatch = useAppDispatch()
  const collapsedPanel = useSelector((state: RootState) => state.editor.collapsedPanel)
  const solidMeshState = useSelector((state: RootState) => state.solidMesh.state)
  const solidMeshProgress = useSelector((state: RootState) => state.solidMesh.progress)

  return (
    <HStack h="100%" id="panel-container">
      {solidMeshState !== MeshState.None && (
        <HStack bgColor="black" borderColor="gray2.800" borderWidth="1px" px={2} height="32px" borderRadius="md">
          <Image src={LoadingAnimation} h="28px" />
          {solidMeshState === MeshState.Processing && <Text>3Dメッシュデータ処理中...</Text>}
          {solidMeshState === MeshState.Loading && solidMeshProgress !== undefined && (
            <>
              <Text>3Dメッシュデータ読み込み中... </Text>
              <Text w="36px" textAlign="right">
                {Math.round(solidMeshProgress * 100)}%
              </Text>
            </>
          )}
        </HStack>
      )}
      <IconButton
        bg="gray2.900"
        color="white"
        borderRadius="md"
        aria-label=""
        size="sm"
        className={['collapse-all-panel', collapsedPanel.length !== 3 ? '' : 'collapsed'].join(' ')}
        _hover={{ bg: 'gray2.700' }}
        onClick={() =>
          dispatch(
            setCollapsedPanel(
              collapsedPanel.length !== 3 ? [PanelType.Settings, PanelType.Elements, PanelType.Tool] : [],
            ),
          )
        }
      >
        <ChevronRightIcon width="1.5rem" height="1.5rem" />
      </IconButton>
      <VStack width={INFO_PANEL_WIDTH} h="100%" className="panel-stack">
        <SettingsPanel />

        <ElementsPanel />

        <ToolsPanel toolsConfig={toolsConfig} />
      </VStack>
    </HStack>
  )
}

export default SidePanels
